import { SidebarMenu } from '../../../enum/SidebarMenu';

import { logout } from '../../auth';

import icon from '../../../assets/img/svg/sidebar/user-avatar.svg';

export const createUserMenu = (username: string) => ({
  sidebarMenuType: SidebarMenu.USER,
  label: username,
  path: undefined,
  routes: [
    {
      label: 'sidebar.user.logout',
      path: '',
      onClick: () => {
        logout();
      },
      testId: 'logoutbutton',
    },
  ],
  icon,
  testId: 'user',
});
